<template lang="pug">
.HomePage
  .HomePageTopBar
    CarouselBanner
    AnchorPoint
  #IndustryEvent
    IndustryEvent
  #RiskLibrary
    RiskLibrary
  .chartAndContrast
    #CrisisEcharts.left
      CrisisEcharts
    #RiskContrast.right
      RiskContrast
</template>

<script>
import CarouselBanner from './components/CarouselBanner'
import AnchorPoint from './components/AnchorPoint'
import IndustryEvent from './IndustryEvent/IndustryEvent'
import RiskLibrary from './RiskLibrary/RiskLibrary'
import CrisisEcharts from './CrisisEcharts/CrisisEcharts'
import RiskContrast from './RiskContrast/RiskContrast'
export default {
  name: 'HomePage',
  components: {
    CarouselBanner, AnchorPoint, IndustryEvent, RiskLibrary, CrisisEcharts, RiskContrast
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
    toScroll (id) {
      document.querySelector(id).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.HomePage {
  padding-top: 220px;
  height: 100%;
  .HomePageTopBar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .chartAndContrast {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    .left,
    .right {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/HomePage.vue